const $menuItemButtonClick = document.querySelectorAll('[data-role=menu-item-button]');
const $sections = document.querySelectorAll('[data-section-menu=scroll-menu]');

$menuItemButtonClick.forEach((item)=> {
	item.addEventListener('click', (event) => onMenuItemButtonClick(event));
});

function onMenuItemButtonClick(event: Event) {
	const $target = event.currentTarget as HTMLElement;
	const $scrollBlock = document.querySelector(`[data-role=${$target.getAttribute('data-block')}]`) as HTMLElement;

	$menuItemButtonClick.forEach((item)=> {
		item.classList.remove('_active');
	});

	$target.classList.add('_active');
	$scrollBlock.setAttribute('isScrollOnClick', 'true');

	$scrollBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });

	setTimeout(()=> {
		$scrollBlock.removeAttribute('isScrollOnClick');
	}, 1000);
}

const observer = new IntersectionObserver((entries) => {
	entries.forEach(entry => {
		const $entryTarget = entry.target;
		const $activeMenuItem = document.querySelector(`[data-block=${$entryTarget.getAttribute('data-role')}]`);

		if ($entryTarget.hasAttribute('isScrollOnClick')) return;

		$activeMenuItem?.classList.toggle('_active', entry.isIntersecting);
	});
}, { threshold: 0.15 });

$sections.forEach((item) => {
	observer.observe(item);
});